import {DxOperationResultType} from "../../../dx-core/domain/common/dx-operation-result-type";

export class DxLogoutResult {
  private _type: DxOperationResultType;

  /** Причина проваленной аунтификации **/
  private _error: string;

  get type(): DxOperationResultType {
    return this._type;
  }

  set type(value: DxOperationResultType) {
    this._type = value;
  }

  get error(): string {
    return this._error;
  }

  set error(value: string) {
    this._error = value;
  }
}
